<div class="flexColumn flexFill" style="height: 100%;">


  <div class="flexColumn dx-card flat" style="padding: 20px">
    <span style="font-size: 20px; font-family: Montserrat, Helvetica Neue, sans-serif !important;">{{
      'ALERT.FORM.ORIGIN' | translate }}</span>
    <div class="flexColumn" style="gap: 4px">
      <span [ngClass]="editEnabled? '' : 'label-disabled'">{{ 'ALERT.FORM.DEVICE' | translate }}</span>
      <app-device-selector #deviceSelectorComponent (selectedDeviceIdChange)="checkFormValidity()"
        [(selectedDeviceId)]="alarmService.selectedDeviceId" [disabled]="selectedItem.id !== undefined || !editEnabled"
        [inputDisplayMode]="'dropdown'" [selectedPartitionId]="partitionId" class="flexFill">
      </app-device-selector>
    </div>
    <div class="flexColumn" style="gap: 4px">
      <span [ngClass]="editEnabled? '' : 'label-disabled'">{{ 'ALERT.FORM.METRIC' | translate }}</span>
      <app-metric-selector (selectedMetricIdsChange)="checkFormValidity()"
        (selectedMetricsChange)="initializeMetricAlarm($event[0])" [(selectedMetricIds)]="selectedMetricIds"
        [deviceList]="deviceSelectorComponent.deviceList"
        [disabled]="alarmService.selectedDeviceId === undefined || alarmService.selectedDeviceId === null || selectedItem.id !== undefined || !editEnabled"
        [inputDisplayMode]="'dropdown'" [selectedDeviceId]="alarmService.selectedDeviceId"
        [selectedPartitionId]="partitionId" [selectionMode]="'single'" class="flexFill">
      </app-metric-selector>
    </div>
  </div>

  <div *ngIf="!!selectedItem && !!selectedItem.additionalInfo" class="flexColumn flexFill">
    <div class="flexColumn flexFill">
      <div class="flexColumn dx-card flat" style="padding: 20px">
        <span style="font-size: 20px; font-family: Montserrat, Helvetica Neue, sans-serif !important;">{{
          'ALERT.FORM.CONFIG' | translate }}</span>
        <dx-text-box #nameTextBox (onValueChanged)="checkFormValidity()" [(value)]="selectedItem.name"
          [disabled]="!editEnabled" [maxLength]="gmService.STR_DIM_BIG" label="{{ 'ALERT.FORM.NAME' | translate }} *"
          valueChangeEvent="keyup"></dx-text-box>

        <div [ngClass]="appService.isMediumScreen()? 'flexColumn' : 'flexRow'" style="justify-content: space-between;">
          <div class="flexRow" style="justify-content: space-between"><span
              [ngClass]="editEnabled? '' : 'label-disabled'">{{ 'ALERT.FORM.ENABLED' | translate }}</span>
            <dx-switch (onValueChanged)="checkFormValidity()" [(value)]="selectedItem.enabled"
              [disabled]="!editEnabled">
            </dx-switch>
          </div>
          <div class="flexRow" style="justify-content: space-between"><span
              [ngClass]="editEnabled? '' : 'label-disabled'">{{ 'ALERT.FORM.BEGIN_NOTIFICATIONS' | translate }}</span>
            <dx-switch (onValueChanged)="checkFormValidity()" [(value)]="selectedItem.beginAlarmNotificationOn"
              [disabled]="!editEnabled">
            </dx-switch>
          </div>
          <div class="flexRow" style="justify-content: space-between"><span
              [ngClass]="editEnabled? '' : 'label-disabled'">{{ 'ALERT.FORM.END_NOTIFICATIONS' | translate }}</span>
            <dx-switch (onValueChanged)="checkFormValidity()" [(value)]="selectedItem.endAlarmNotificationOn"
              [disabled]="!editEnabled">
            </dx-switch>
          </div>
        </div>
        <dx-select-box
          (onValueChanged)="onAlarmTypeChanged()"
          [(value)]="selectedItem.alarmType"
          [disabled]="!editEnabled"
          [displayExpr]="translateAlarmType"
          [items]="alarmTypeItems"
          label="{{ 'ALERT.FORM.ALARM_TYPE' | translate }}">
        </dx-select-box>
        <!--  STATIC ALARM  -->
        <div *ngIf="selectedItem.alarmType === AlarmTypeEnum.STATIC && !!selectedItem.additionalInfo.staticAlarm"
             [ngClass]="appService.isMediumScreen()? 'flexColumn' : 'flexRow'">
          <dx-select-box
            (onValueChanged)="checkFormValidity()"
            [(value)]="selectedItem.additionalInfo.staticAlarm.alarmOnChange"
            [disabled]="!editEnabled"
            [displayExpr]="translateStaticMode"
            [items]="[false, true]"
            class="flexFill"
            label="{{ 'ALERT.FORM.STATIC_MODE' | translate }}">
          </dx-select-box>
          <dx-number-box
            #intervalNumBox
            (onValueChanged)="checkFormValidity()"
            [(value)]="selectedItem.additionalInfo.staticAlarm.intervalMinutes"
            [disabled]="!editEnabled"
            [min]="STATIC_ALARM_SLOT_MINUTES"
            [step]="STATIC_ALARM_SLOT_MINUTES"
            [showSpinButtons]="true"
            class="flexFill"
            format="#0"
            label="{{ 'ALERT.FORM.STATIC_INTERVAL' | translate }} *"
            valueChangeEvent="keyup">
          </dx-number-box>
        </div>
        <ng-container *ngIf="!formValid">
          <span *ngIf="invalidStaticInterval"
                class="alert">*{{ 'ALERT.FORM.STATIC_INTERVAL_INVALID' | translate: {slot: STATIC_ALARM_SLOT_MINUTES} }}</span>
        </ng-container>
        <!--  NUMERIC ALARM  -->
        <div *ngIf="selectedItem.alarmType !== AlarmTypeEnum.STATIC && !!selectedItem.additionalInfo.numericAlarm"
          [ngClass]="appService.isMediumScreen()? 'flexColumn' : 'flexRow'">
          <div [style.justify-content]="appService.isMediumScreen()? 'space-between' : 'flex-start'"
            class="flexRow flexFill">
            <span [ngClass]="editEnabled? '' : 'label-disabled'">{{ 'ALERT.FORM.LOWER_VAL' | translate }}</span>
            <dx-switch (onValueChanged)="checkFormValidity()"
              [(value)]="selectedItem.additionalInfo.numericAlarm.lowerLimitEnabled" [disabled]="!editEnabled">
            </dx-switch>
            <dx-number-box #lowerNumBox (onValueChanged)="checkFormValidity()"
              [(value)]="selectedItem.additionalInfo.numericAlarm.lowerValue"
              [disabled]="!selectedItem.additionalInfo.numericAlarm.lowerLimitEnabled || !editEnabled"
              [showSpinButtons]="true" valueChangeEvent="keyup">
            </dx-number-box>
          </div>
          <div [style.justify-content]="appService.isMediumScreen()? 'space-between' : 'flex-end'"
            class="flexRow flexFill">
            <span [ngClass]="editEnabled? '' : 'label-disabled'">{{ 'ALERT.FORM.UPPER_VAL' | translate }}</span>
            <dx-switch (onValueChanged)="checkFormValidity()"
              [(value)]="selectedItem.additionalInfo.numericAlarm.upperLimitEnabled" [disabled]="!editEnabled">
            </dx-switch>
            <dx-number-box #upperNumBox (onValueChanged)="checkFormValidity()"
              [(value)]="selectedItem.additionalInfo.numericAlarm.upperValue"
              [disabled]="!selectedItem.additionalInfo.numericAlarm.upperLimitEnabled || !editEnabled"
              [showSpinButtons]="true" valueChangeEvent="keyup">
            </dx-number-box>
          </div>
        </div>
        <ng-container *ngIf="!formValid">
          <span *ngIf="lowerGreaterThanUpper" class="alert">*{{ 'ALERT.FORM.LOWER_GREATER_THAN_UPPER' | translate
            }}</span>
        </ng-container>
        <!--   STRING ALARM   -->
        <div *ngIf="selectedItem.alarmType !== AlarmTypeEnum.STATIC && !!selectedItem.additionalInfo.stringAlarm">
          <dx-tag-box #phoneTagBox (onValueChanged)="checkFormValidity()" (openedChange)="phoneTagBox.instance.close()"
            [(value)]="selectedItem.additionalInfo.stringAlarm.alarmValues" [acceptCustomValue]="true"
            [disabled]="!editEnabled" class="flexFill" placeholder="{{ 'ALERT.FORM.STRING_VAL' | translate }}"
            style="width: 100%;">
          </dx-tag-box>
        </div>
        <!--   BOOL ALARM   -->
        <div *ngIf="selectedItem.alarmType !== AlarmTypeEnum.STATIC && !!selectedItem.additionalInfo.booleanAlarm">
          <div class="flexFill">
            <span [ngClass]="editEnabled? '' : 'label-disabled'">{{ 'ALERT.FORM.BOOLEAN_VAL' | translate }}</span>
            <dx-select-box (onValueChanged)="checkFormValidity()"
              [(value)]="selectedItem.additionalInfo.booleanAlarm.alarmValue" [disabled]="!editEnabled"
              [displayExpr]="translateBooleanSelector" [items]="[true, false]">
            </dx-select-box>
          </div>
        </div>
      </div>

      <div class="flexColumn dx-card flat" style="padding: 20px">
        <span style="font-size: 20px; font-family: Montserrat, Helvetica Neue, sans-serif !important;">{{
          'ALERT.FORM.SCHEDULE' | translate }}</span>
        <div id="alertScheduleRow" class="flexColumn" style="justify-content: space-between; align-items: start;">
          <dx-radio-group (onValueChanged)="onCustomMonitoringTimeChange($event.value)" [disabled]="!editEnabled"
            [items]="[false, true]" [value]="customMonitoringTime" id="calendarModeRadio" layout="horizontal">
            <div *dxTemplate="let custom of 'item'">
              {{ (custom ? 'ALERT.FORM.SCHEDULE_CUSTOM' : 'ALERT.FORM.SCHEDULE_ALWAYS') | translate }}
            </div>
          </dx-radio-group>
          <app-week-grid (click)="openCalendarPopup()" (keydown.enter)="openCalendarPopup()"
            *ngIf="customMonitoringTime" [attr.title]="(editEnabled ? 'ALERT.FORM.SCHEDULE_CONFIGURE' : 'ALERT.FORM.SCHEDULE_VISUALIZE') | translate"
            [compact]="true" [value]="selectedItem.calendar" class="clickable" role="button" style="width: 100%"
            tabindex="0">
          </app-week-grid>
          <span *ngIf="customMonitoringTime && !selectedItem.calendar" class="alert">*{{
            'ALERT.FORM.SCHEDULE_EMPTY' | translate }}</span>
        </div>

        <div *ngIf="customMonitoringTime" class="flexColumn"
          style="justify-content: space-between; align-items: start; gap: 10px;">

          <div class="flexRow" style="justify-content: space-between; align-items: center">
            <dx-select-box id="calendarRenotifySelect" (onValueChanged)="onRenotifyModeChange($event.value)"
              [disabled]="!editEnabled" [displayExpr]="translateRenotifyMode" [items]="renotifyModes"
              [value]="renotifyMode" hint="{{ 'ALERT.FORM.SCHEDULE_RENOTIFY_HINT' | translate }}"
              label="{{ 'ALERT.FORM.SCHEDULE_RENOTIFY' | translate }}" [width]="240">
            </dx-select-box>
            <dx-number-box id="calendarCooldownBox" (onValueChanged)="onCooldownChange($event.value)"
              *ngIf="renotifyMode === 'AFTER_TIME'" [disabled]="!editEnabled" [format]="'#0'" [min]="1"
              [showSpinButtons]="true" [value]="selectedItem.alarmCooldownSec ?? DEFAULT_COOLDOWN_SEC" [width]="200"
              hint="{{ 'ALERT.FORM.SCHEDULE_COOLDOWN_HINT' | translate }}"
              label="{{ 'ALERT.FORM.SCHEDULE_COOLDOWN' | translate }}">
            </dx-number-box>
          </div>
          <div class="flexRow" style="justify-content: space-between; margin-top: 10px;">
            <span [ngClass]="editEnabled? '' : 'label-disabled'">{{ 'ALERT.FORM.SCHEDULE_FORCED_RECOVERY' | translate
              }}</span>
            <dx-switch id="calendarForcedRecoverySwitch"
              (onValueChanged)="selectedItem.calendarForcedRecovery = $event.value; checkFormValidity()"
              [disabled]="!editEnabled" [value]="!!selectedItem.calendarForcedRecovery">
            </dx-switch>
          </div>
        </div>
        <app-weekly-selector (valueChange)="onCalendarChange($event)" [(popupVisible)]="calendarPopupVisible"
          [editMode]="calendarPopupEditMode" [value]="selectedItem.calendar">
        </app-weekly-selector>
      </div>

      <div class="flexColumn dx-card flat flexFill" style="padding: 20px 20px 0 20px; width: 100%">


        <span style="font-size: 20px; font-family: Montserrat, Helvetica Neue, sans-serif !important;">{{
          'ALERT.FORM.CONTACTS' | translate }}</span>
        <ng-container *ngIf="!formValid">
          <span *ngIf="userMustAddContacts" class="alert">*{{ 'ALERT.FORM.USER_MUST_ADD_CONTACTS' | translate }}</span>
          <span *ngIf="userMustDeleteContacts" class="alert">*{{ 'ALERT.FORM.USER_MUST_DELETE_CONTACTS' | translate
            }}</span>
        </ng-container>

        <div [style.height.px]="appService.isMediumScreen()? 400 : 250"
          [ngClass]="appService.isMediumScreen()? 'flexColumn' : 'flexRow'"
          style="align-items: flex-start; height: 250px">

          <div class="flexColumn flexFill" style="gap: 0; width: 100%; height:100%; overflow: hidden">
            <div class="flexRow" style="align-items: flex-end">

              <dx-text-box #emailTextBox (onEnterKey)="addEmail(emailTextBox)" [(value)]="email" [maxLength]="gmService.STR_DIM_MID"
                [disabled]="!editEnabled || (!this.selectedItem.beginAlarmNotificationOn && !this.selectedItem.endAlarmNotificationOn)"
                class="flexFill" label="{{ 'ALERT.FORM.EMAIL' | translate }}">
                <dx-validator>
                  <!--                  <dxi-validation-rule type="required"></dxi-validation-rule>-->
                  <dxi-validation-rule [pattern]="appService.EMAIL_PATTERN" type="pattern"></dxi-validation-rule>
                  <dxi-validation-rule [reevaluate]="true" [validationCallback]="checkEmailDuplicates"
                    type="custom"></dxi-validation-rule>
                </dx-validator>
              </dx-text-box>

              <dx-select-box [(value)]="selectedLangEmail"
                [disabled]="!editEnabled || (!this.selectedItem.beginAlarmNotificationOn && !this.selectedItem.endAlarmNotificationOn)"
                [items]="languages" label="{{ 'ALERT.FORM.LANGUAGE' | translate }}" style="width: 100px">
              </dx-select-box>

              <dx-button (onClick)="addEmail(emailTextBox)"
                [disabled]="!email || !emailTextBox.isValid || !editEnabled || (!this.selectedItem.beginAlarmNotificationOn && !this.selectedItem.endAlarmNotificationOn)"
                [icon]="'add'" stylingMode="text"></dx-button>

            </div>

            <dx-list [scrollingEnabled]="true" (itemsChange)="checkFormValidity()"
              [items]="selectedItem.additionalInfo.emailReceivers" [allowItemDeleting]="false" [disabled]="!editEnabled"
              [itemTemplate]="'listTemplate'">

              <div *dxTemplate="let item of 'listTemplate'; index as index">
                <div style="display: flex; justify-content: space-between; align-items: center">
                  <span>{{ item.value }}</span>
                  <div>
                    <span>{{ item.language }}</span>
                    <span>
                      <dx-button (onClick)="deleteEmailReceiver($event,index)" [class]="'smallButtonIcons'"
                        [elementAttr]="{class:'outlinedRedButton'}" [stylingMode]="'text'" [visible]="editEnabled">
                        <i class="vr-ic_fluent_delete_24_regular"></i>
                      </dx-button>
                    </span>
                  </div>
                </div>
              </div>
            </dx-list>

          </div>

          <div class="flexColumn flexFill" style="gap: 0; width: 100%; height:100%; overflow: hidden">
            <div class="flexRow" style="align-items: flex-end">

              <dx-text-box #phoneBox (onEnterKey)="addPhoneNumber(phoneBox)" [(value)]="phoneNumber" [maxLength]="gmService.STR_DIM_MIN"
                [disabled]="!editEnabled || (!this.selectedItem.beginAlarmNotificationOn && !this.selectedItem.endAlarmNotificationOn)"
                class="flexFill" label="{{ 'ALERT.FORM.PHONE' | translate }}" valueChangeEvent="keyup">
                <dx-validator>
                  <!--                  <dxi-validation-rule type="required"></dxi-validation-rule>-->
                  <dxi-validation-rule [pattern]="this.appService.PHONE_REGEX" type="pattern"></dxi-validation-rule>
                  <dxi-validation-rule [reevaluate]="true" [validationCallback]="checkPhoneDuplicates"
                    type="custom"></dxi-validation-rule>
                </dx-validator>
              </dx-text-box>

              <dx-select-box [(value)]="selectedLangPhone"
                [disabled]="!editEnabled || (!this.selectedItem.beginAlarmNotificationOn && !this.selectedItem.endAlarmNotificationOn)"
                [items]="languages" label="{{ 'ALERT.FORM.LANGUAGE' | translate }}" style="width: 100px">
              </dx-select-box>

              <dx-button (onClick)="addPhoneNumber(phoneBox)"
                [disabled]="!phoneNumber || !phoneBox.isValid || !editEnabled || (!this.selectedItem.beginAlarmNotificationOn && !this.selectedItem.endAlarmNotificationOn)"
                [icon]="'add'" stylingMode="text">
              </dx-button>
            </div>

            <div style="flex: 1 1 auto; overflow: hidden">
              <dx-list (itemsChange)="checkFormValidity()" [items]="selectedItem.additionalInfo.phoneReceivers"
                [allowItemDeleting]="false" [disabled]="!editEnabled" [itemTemplate]="'listTemplate'">
                <div *dxTemplate="let item of 'listTemplate'; index as index">
                  <div style="display: flex; justify-content: space-between; align-items: center">
                    <span>{{ item.value }}</span>
                    <div>
                      <span>{{ item.language }}</span>
                      <span>
                        <dx-button (onClick)="deletePhoneNumberReceiver($event, index)" [class]="'smallButtonIcons'"
                          [elementAttr]="{class:'outlinedRedButton'}" [stylingMode]="'text'" [visible]="editEnabled">
                          <i class="vr-ic_fluent_delete_24_regular"></i>
                        </dx-button>
                      </span>
                    </div>
                  </div>
                </div>
              </dx-list>
            </div>


          </div>

        </div>


      </div>

    </div>
  </div>
</div>
